// src/App.js
import React from 'react';
import './App.css';
import {
  HashRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material'; // Import ThemeProvider
import theme from './theme'; // Import your custom theme

import Navbar from './site/components/NavBar';
import Home from './site/pages/Home';
import About from './site/pages/About';
import Ownership from './site/pages/Ownership';
import Projects from './site/pages/Projects';
import ProjectDetail from './site/pages/ProjectDetail';
import Footer from './site/components/Footer'; // Make sure Footer exists
import LEDController from './LEDApp/LEDController';
import GoneFishinLegal from './site/pages/GoneFishinLegal';

const GONE_FISHIN_BUILD_VERSION = '20260822-1323';

function GoneFishin() {
  return (
    <div className="gone-fishin-route">
      <iframe
        title="Gone Fishin' game"
        src={`/gone-fishin/index.html?v=${GONE_FISHIN_BUILD_VERSION}`}
        className="gone-fishin-frame"
        allow="fullscreen; autoplay"
      />
    </div>
  );
}

function Layout({ children }) {
  const location = useLocation();

  // Exclude Navbar for specific routes
  const hideNavbarRoutes = ['/LEDApp', '/gone-fishin', '/gone-fishin/terms', '/gone-fishin/privacy', '/gone-fishin/publisher'];
  const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

  return (
    <>
      {!shouldHideNavbar && <Navbar />}
      {children}
      {!shouldHideNavbar && <Footer />}
    </>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/ownership" element={<Ownership />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            {/* LED App */}
            <Route path="/LEDApp" element={<LEDController />} />
            <Route path="/gone-fishin" element={<GoneFishin />} />
            <Route path="/gone-fishin/terms" element={<GoneFishinLegal type="terms" />} />
            <Route path="/gone-fishin/privacy" element={<GoneFishinLegal type="privacy" />} />
            <Route path="/gone-fishin/publisher" element={<GoneFishinLegal type="publisher" />} />
          </Routes>
        </Layout>
      </Router>
    </ThemeProvider>
  );
}

export default App;













